// extracted by mini-css-extract-plugin
module.exports = {"defaultUnitValue":"8px","gridOffset":"grid-module--gridOffset--3FBW7","banner":"banner-module--banner--1_fTQ grid-module--gridOffset--3FBW7"};